import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Product, ProductConvert, ProductTemp, ProductTempBase, ProductTempCollection, ProductTempFilters } from '../interfaces';
import { ApiResult, ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ProductTempService extends ApiService {

  public get(id: string | number, filters: ProductTempFilters = {}): Observable<ProductTemp> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.get<ApiResult<ProductTemp>>(`${this.apiUrl}/produits_temporaires/${id}${queryString}`)
      .pipe(map((ar: ApiResult<ProductTemp>) => ar.result))
  }

  public getCollection(filters: ProductTempFilters = {}): Observable<ProductTempCollection> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.get<ProductTempCollection>(`${this.apiUrl}/produits_temporaires/${queryString}`)
  }

  public post(data: Partial<ProductTempBase>, filters: ProductTempFilters = {}): Observable<ProductTemp> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.post<ApiResult<ProductTemp>>(`${this.apiUrl}/produits_temporaires/${queryString}`, data)
      .pipe(map((ar: ApiResult<ProductTemp>) => ar.result))
  }

  public patch(id: string | number, data: Partial<ProductTempBase>, filters: ProductTempFilters = {}): Observable<ProductTemp> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.patch<ApiResult<ProductTemp>>(`${this.apiUrl}/produits_temporaires/${id}${queryString}`, data)
      .pipe(map((ar: ApiResult<ProductTemp>) => ar.result))
  }

  public delete(id: string | number): Observable<string> {
    return this.http.delete<string>(`${this.apiUrl}/produits_temporaires/${id}`)
  }

  public postConvertir(id: string | number): Observable<ProductConvert> {
    return this.http.post<ProductConvert>(`${this.apiUrl}/produits_temporaires/${id}/convertir`, {})
  }
}
